// @flow
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import './styles.scss'

class AppComponent extends Component<{}> {
  state: State = {
    personName: 'Name nicht gesetzt',
    description: 'Beschreibung nicht gesetzt',
    imageUrl:
      'http://interaktiv.tagesanzeiger.ch/2019/got-charakteren/dummy.jpg'
  }

  componentDidMount() {
    let params = new URL(window.location).searchParams
    let name = params.get('name')
    let beschreibung = params.get('beschreibung')
    let bild = params.get('bild')

    if (bild !== null) {
      this.setState({ imageUrl: decodeURI(bild) })
    }
    if (name !== null) {
      this.setState({ personName: decodeURI(name) })
    }
    if (beschreibung !== null) {
      this.setState({ description: decodeURI(beschreibung) })
    }
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ui container'>
          <div className='ui'>
            <div className='content' style={{ textAlign: 'center' }}>
              <img
                className='ui medium circular image'
                style={{ margin: '0 auto' }}
                src={this.state.imageUrl}
              />
              <h3>{this.state.personName}</h3>
              <hr />
              <h4>{this.state.description}</h4>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default hot(AppComponent)
